import BigNumber from 'bignumber.js';

export const getSafeBNVariables = (
  variables?: object,
): Record<string, object> => {
  if (
    typeof variables !== 'object' ||
    Array.isArray(variables) ||
    variables === null
  ) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(variables).map(([key, value]) => [
      key,
      BigNumber.isBigNumber(value) ? value.toString() : value,
    ]),
  );
};
